'use strict';

var _ = require('lodash');
var DemandTransparencyUntruncatedMdChartTransformerFactory = function DemandTransparencyUntruncatedMdChartTransformerFactory(DataTransformer, momentService) {
  function DemandTransparencyUntruncatedMdChartTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'demand-transparency-untruncated-md-mode';
    this.targetType = 'demand-transparency-dtd-chart';
    this.priority = 1;
  }
  DemandTransparencyUntruncatedMdChartTransformer.prototype = Object.create(DataTransformer.prototype);
  DemandTransparencyUntruncatedMdChartTransformer.constructor = DemandTransparencyUntruncatedMdChartTransformer;
  DemandTransparencyUntruncatedMdChartTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  DemandTransparencyUntruncatedMdChartTransformer.prototype.isCacheable = function () {
    return false;
  };
  DemandTransparencyUntruncatedMdChartTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  DemandTransparencyUntruncatedMdChartTransformer.prototype.transform = function (data) {
    if (data.domain.results === undefined) {
      return undefined;
    }
    var memoizedMomentOfDate = _.memoize(getMomentOfDate);
    var results = [];
    _.forEach(data.domain.results, function (e) {
      var momentDepartureDate = memoizedMomentOfDate(e.departureDate, momentService.FIELD.DEPARTURE_DATE);
      results.push({
        carrier: e.carrier,
        season: e.season,
        seasonOverride: e.seasonOverride,
        dowGroup: e.dowGroup,
        isMappedOutlier: e.isMappedOutlier,
        isRegularOutlier: e.isRegularOutlier,
        classGroupName: e.classGroupName,
        departureDate: momentDepartureDate,
        significantPOS: e.significantPOS,
        daysToDepartures: _.sortBy(e.daysToDepartures, 'daysToDeparture')
      });
    });
    return results;
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  return DemandTransparencyUntruncatedMdChartTransformer;
};
DemandTransparencyUntruncatedMdChartTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = DemandTransparencyUntruncatedMdChartTransformerFactory;